<div class="form-title-container" #formTitleArea>
  <div class="form-title-bar">
    <div class="form-title">{{formTitle}}</div>
  </div>
</div>